// This store contains shared component state, please keep it slim and consider events before adding more here.
import { writable } from 'svelte/store';

export const _l10n = writable({});

export const _env = writable('');
